import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=0093e530"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
import style0 from "./Index.vue?vue&type=style&index=0&id=0093e530&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kemingchen/Projects/VisionFutureWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0093e530')) {
      api.createRecord('0093e530', component.options)
    } else {
      api.reload('0093e530', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=0093e530", function () {
      api.rerender('0093e530', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/News/Index.vue"
export default component.exports